import { AxiosResponse } from 'axios';
import AppConstants from '../constants/AppConstants';
import { PreCheckQuestionReq, PreCheckQuestionRes, PreCheckQuestionResPage } from '../proxy/proxy';
import { AxiosPreCheckQuestionsClient } from '../proxy/ProxyClients';

const PreCheckQuestionsService = {
  getAllQuestions: () => AxiosPreCheckQuestionsClient.page({
    pageNumber: 1,
    pageSize: AppConstants.MAX_PAGE_SIZE
  }).then((resp: PreCheckQuestionResPage) => {
    const result: Array<PreCheckQuestionRes> = resp?.items || [];
    return result.filter((question: any) => !question.isSoftDeleted);
  }),
  getQuestionById: (id: number) => AxiosPreCheckQuestionsClient.get(id).then((resp) => resp),
  createQuestion: (data: PreCheckQuestionReq) => AxiosPreCheckQuestionsClient.create(data),
  updateQuestion: (id: number, data: PreCheckQuestionReq) => AxiosPreCheckQuestionsClient.update(id, data),
  deleteQuestion: (id: number = 0) => AxiosPreCheckQuestionsClient.softDelete(id)
};

export default PreCheckQuestionsService;
